import { SAVE_SOCKET_JWT_TOKEN } from '../../util/actionTypes';
const initialState = {data:{}};

const socketJwtReducer = (state =initialState, action) => {

    switch (action.type) {
        case SAVE_SOCKET_JWT_TOKEN: 
            return {
                ...state,
                data :action.payload, 
            };     

        default:
            return state;
    }
};

export default socketJwtReducer;
